import { useQuery } from '@tanstack/react-query'
import { ApiError } from '@/shared/api/client'
import { queryKeys } from '@/shared/api/queryKeys'
import { sessionApi } from './api'

/**
 * Текущий вход.
 *
 * Единственный источник правды о том, кто вошёл. Копии в Zustand нет
 * намеренно: она разъезжается с сервером, и разъехавшись, показывает
 * старое название компании ещё сутки после переименования.
 */
export function useAccount() {
  return useQuery({
    queryKey: queryKeys.account,
    queryFn: ({ signal }) => sessionApi.me(signal),
    // 401 — это не сбой связи, а «не вошёл». Повторять запрос бесполезно:
    // ответ не изменится, а человек три секунды смотрит на пустой экран
    // вместо формы входа.
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status < 500) return false
      return failureCount < 2
    },
    staleTime: 60_000,
  })
}
